/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsStaffCostCtrl
 */
angular.module('mercury.modules.reports.staff')
.controller('ReportsStaffCostCtrl', ["$filter", "$q", "$scope", "reporttime", "TimeClock", "title", function($filter, $q, $scope, reporttime, TimeClock, title) {
  title.set('Staff Cost');

  $scope.loading = $q.all({
    intervalCost: TimeClock.getSummaryByInterval(reporttime.start(), reporttime.end(), reporttime.interval()),
    staffCost: TimeClock.getSummaryByStaff(reporttime.start(), reporttime.end())
  });

  $scope.loading.then(function(results) {
    $scope.intervalCost = results.intervalCost;
    $scope.staffCost = results.staffCost;

    $scope.showStaffCost = false;
    $scope.showIntervalCost = false;
    if (results.staffCost && results.staffCost[0] && results.staffCost[0].hasOwnProperty('cost')) {
      $scope.showStaffCost = true;
    }

    if (results.intervalCost && results.intervalCost[0] && $scope.intervalCost[0].hasOwnProperty('cost')) {
      $scope.intervalColumns = [
        {label: 'Time', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
        {label: 'Cost', type: 'number', key: 'cost', filter: 'currency'}
      ];
      $scope.graphOptions = {};
    } else {
      $scope.intervalColumns = [
        {label: 'Time', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
        {label: 'Hours', type: 'number', key: 'hours', filter: 'number'}
      ];
      $scope.graphOptions = {
        vAxis: {format: 'decimal'}
      };
    }
  });
}]);
